import React, {useContext} from 'react';
import {Popup, FormField} from 'components';
import TextareaAutosize from 'react-textarea-autosize';
import {useField} from 'helpers';

export function Textarea({ placeholder, single, required, minRows = single ? 1 : 5, ...props }) {
  const [ field, { error, touched }, , isSubmitting ] = useField(props);
  const popup = useContext(Popup.Context);
  return (
    <FormField invalid={error && touched} {...props} value={field.value} >
      <TextareaAutosize
        {...field}
        autoComplete="off"
        disabled={isSubmitting}
        maxRows={Math.max(popup ? 10 : 5, minRows)}
        minRows={minRows}
        placeholder={placeholder}
        required={required}
      />
    </FormField>
  );
}
